import axios from 'axios'
import { getCookie, setCookie } from './Utils/Cookies.js'
import { useParams, useNavigate } from 'react-router-dom'
import { login, logout } from './Utils/Cookies.js';

const apiUrl = process.env.REACT_APP_API_URL

const myApi = axios.create({
  baseURL: apiUrl,
  timeout: 10 * 1000,
})

const longApi = axios.create({
  baseURL: apiUrl,
})

const getAccessToken = async () => {
  return {
    "accessToken": getCookie("accessToken")
  }
}

const tbrosApi = {
  apiUrl: apiUrl,
  async postLong(uri, data) {
    try {
      const token = await getAccessToken()
      return await longApi.post("/api" + uri, data, {
        headers: {
          ...token
        }
      })
    } catch (error) {
      this.errorHandle(error)
    }
  },

  async post(uri, data, customHandler) {
    try {
      const token = await getAccessToken()
      return await myApi.post("/api" + uri, data, {
        headers: {
          ...token,
          "Content-Type": "application/json"
        }
      })
    } catch (error) {
      if (customHandler) {
        customHandler(error)
      } else {
        this.errorHandle(error)
      }
    }
  },
  async delete(uri, headers) {
    const token = await getAccessToken()
    try {
      return await myApi.delete("/api" + uri, {
        headers: {
          ...token,
          ...headers
        }
      })
    } catch (error) {
      this.errorHandle(error)
    }
  },
  async get(uri, customHandler) {
    const token = await getAccessToken()
    try {
      return await myApi.get("/api" + uri, {
        headers: {
          ...token,
        }
      })
    } catch (error) {
      if (customHandler) {
        customHandler(error)
      } else {
        this.errorHandle(error)
      }
    }
  },
  async getWithoutToken(uri, customHandler) {
    try {
      return await myApi.get("/api" + uri, {
        headers: {
        }
      })
    } catch (error) {
      if (customHandler) {
        customHandler(error)
      } else {
        this.errorHandle(error)
      }
    }
  },
  async putLong(uri, data, customHandler) {
    const token = await getAccessToken()
    try {
      return await longApi.put("/api" + uri, data, {
        headers: {
          ...token,
        }
      })
    } catch (error) {
      if (customHandler) {
        customHandler(error)
      } else {
        this.errorHandle(error)
      }
    }
  },
  async put(uri, data, customHandler) {
    const token = await getAccessToken()
    try {
      return await myApi.put("/api" + uri, data, {
        headers: {
          ...token,
        }
      })
    } catch (error) {
      if (customHandler) {
        customHandler(error)
      } else {
        this.errorHandle(error)
      }
    }
  },
  errorHandle(error) {
    switch (error.response && error.response.status || 0) {
      case 401:
        logout()
        alert("로그인이 필요합니다.")
        window.location = `/login`
        break;
      case 502:
        window.location = `/maintenance`
        break;
      default:
        let message = error.response && error.response.data && error.response.data.message || error.message
        if (message == "호스트가 존재하지 않습니다.") {
          window.location = '/join'
        } else {
          alert(message)
        }
        break;
    }
  },
}

export default tbrosApi
